import { printDate } from "../../../utils/dateParser";
import { QUOTE_CONST } from "../../../constants";

const parsePolicyActivity = (eventHistory, revisionHistory) =>
  [
    ...eventHistory
      .filter(event => event.type !== "sendToPrintVendor")
      .map(record => ({
        ...record,
        historyType: "Transaction"
      })),
    ...revisionHistory
      .filter(revision => revision.type === "MortgageeChanges")
      .map(record => ({
        ...record,
        historyType: "Request"
      }))
  ]
    .sort(
      (a, b) =>
        new Date(b.timeStamp).valueOf() - new Date(a.timeStamp).valueOf()
    )
    .map(({ historyType, type, EffectiveDate, timeStamp }) => ({
      timeStamp,
      type: historyType,
      description: type || QUOTE_CONST.EMPTY_VALUE_PLACEHOLDER,
      effectiveDate: EffectiveDate
        ? printDate(EffectiveDate, "MM/dd/yyyy")
        : QUOTE_CONST.EMPTY_VALUE_PLACEHOLDER,
      postedDate: printDate(timeStamp, "MM/dd/yyyy 'at' hh:mmaaa")
    }));

export default parsePolicyActivity;
